import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/reviews/ReviewsWrapper.tsx");
